import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Modal, Button } from 'react-bootstrap';
import history from '../../../../../../history';

const FeatureLockedModal = ({ showFeatureLockedModal, setShowFeatureLockedModal, onCreateFreeAccountClick, onLoginClick }) => {

  const handleClose = () => {
    setShowFeatureLockedModal(false);
  };

  return (
    <Modal show={showFeatureLockedModal} onHide={handleClose} centered size="md">
      <Modal.Body className="p-4">
        <h3 className="title-section pt-5 text-center">Create a <span className="text-blue pointer" onClick={() => history.push('/pricing')}>Free</span> account</h3>
        <div style={{ width: '200px' }} className="mx-auto py-4">
          <img src={require('../../../../../../images/undraw_secure_login_pdn4.svg').default} className="img-fluid" alt="logo" />
        </div>
        <p className="text-lg text-center">You need to have a free <span className="text-blue pointer" onClick={() => history.push('/pricing')}>Community</span> account to use this feature</p>

        <div className="d-flex justify-content-center pt-4">
          <Button variant="outline-primary" onClick={handleClose}>Cancel</Button>
          <Button variant="primary" className="ml-3" onClick={onCreateFreeAccountClick}>Create a FREE Account</Button>
        </div>

        <p className="need-account">
          Already a TruKno user?
          <span style={{ cursor: "pointer" }} onClick={() => {
            setShowFeatureLockedModal(false);
            return onLoginClick ? onLoginClick() : null;
          }}>
            Login
          </span>
        </p>

      </Modal.Body>
    </Modal>
  );
};

export default FeatureLockedModal;
